export default __webpack_public_path__ + "static/rankings-c2c51c0c4203ce8a7a1184e47103c741.svg";